import { render } from "./RoundDetails.vue?vue&type=template&id=8285c4a0&scoped=true"
import script from "./RoundDetails.vue?vue&type=script&lang=js"
export * from "./RoundDetails.vue?vue&type=script&lang=js"

import "./RoundDetails.vue?vue&type=style&index=0&id=8285c4a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8285c4a0"]])

export default __exports__